import { Injectable, Output, EventEmitter } from '@angular/core';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { Item } from '../../model/item';

declare var $: any;
@Injectable({
  providedIn: 'root'
})
export class ToolkitService {

  private static wallItemUpdate = false

  private itemUpdate: Item = null;

  private contentDecryp: string = null

  private readonly QUICK_NOTES_KEY = 'plexi_quick_notes';

  /** Variable que almacena las notas que digite el usuario */
  private _quickNotes: string = "";

  // Getter y Setter para manejar localStorage automáticamente
  public get quickNotes(): string {
    if (!this._quickNotes) {
      this._quickNotes = this.loadNotesFromStorage();
    }
    return this._quickNotes;
  }

  public set quickNotes(value: string) {
    this._quickNotes = value;
    this.saveNotesToStorage(value);
  }

  private activeHighlight: Boolean = false

  private activeEraseHighlight: Boolean = false

  readonly CLASS_HIGHLIGHTER = "custom_highlighter"

  readonly CLASS_NOT_HIGHLIGHTER = "custom_nothighlighter"

  /** Flag para manejo de accion notas rápidas */
  public activateQuickNotes: Boolean;

  /** Flag para manejo de accion calculator */
  public activateCalculator: Boolean;

  /** Flag para manejo del pdf */
  public activateShowPdf: Boolean;

  /** Flag para manejo de componente Html */
  public activateShowHtml: Boolean;

  @Output() changeZoom: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() urlZoom: EventEmitter<string> = new EventEmitter<string>();

  constructor(public _configurationControlService: ConfigurationControlService) {
    this.activateQuickNotes = false;
    this.activateCalculator = false;
    this.activateShowPdf = false;
    this.activateShowHtml = false;
    this.activeEraseHighlight = false;
    this.activeHighlight = false;

    // Cargar notas al iniciar el servicio
    this._quickNotes = this.loadNotesFromStorage();
  }

  /**
   * Guarda las notas en localStorage
   */
  private saveNotesToStorage(notes: string): void {
    try {
      localStorage.setItem(this.QUICK_NOTES_KEY, notes);
    } catch (error) {
      console.error('Error al guardar notas en localStorage:', error);
    }
  }

  /**
   * Carga las notas desde localStorage
   */
  private loadNotesFromStorage(): string {
    try {
      const savedNotes = localStorage.getItem(this.QUICK_NOTES_KEY);
      return savedNotes || "";
    } catch (error) {
      console.error('Error al cargar notas desde localStorage:', error);
      return "";
    }
  }

  /**
   * Limpia las notas rápidas (útil al finalizar un examen)
   */
  public clearQuickNotes(): void {
    this._quickNotes = "";
    try {
      localStorage.removeItem(this.QUICK_NOTES_KEY);
    } catch (error) {
      console.error('Error al limpiar notas:', error);
    }
  }

  // Handler reutilizable para prevenir la selección
  private preventSelectStart = (e: Event) => {
    e.preventDefault();
  };

  // Método para deshabilitar la selección (añade el listener)
  private disableSelectStart(): void {
    document.body.addEventListener('selectstart', this.preventSelectStart);
  }

  // Método para habilitar la selección (remueve el listener)
  private enableSelectStart(): void {
    document.body.removeEventListener('selectstart', this.preventSelectStart);
  }


  private isActiveHighlight() {
    return this._configurationControlService.examConfiguration.highligthText
  }

  public loadItem(item: Item, contentDecryp: string) {
    if (this.isActiveHighlight()) {
      this.contentDecryp = this.clearContent(contentDecryp)
      item.contentDecrypted = this.clearContent(item.contentDecrypted)
      this.itemUpdate = item
      this.resetHighLight()
    }
  }

  public setActiveHighlight(active: Boolean) {
    this.activeHighlight = active
    this.activeEraseHighlight = !active
  }

  public initToolKit(nameScript) {
    this.activateQuickNotes = false;
    this.activateCalculator = false;
    // this.quickNotes = "";
    this.activateShowPdf = false;
    this.activateShowHtml = false;
    this.loadScript(nameScript);
  }

  private setWallFalse() {
    setTimeout(() => { ToolkitService.wallItemUpdate = false }, 500)
  }

  public eventHighlightText() {
    try {
      if (this._configurationControlService.examConfiguration.highligthText && ToolkitService.wallItemUpdate == false && this.itemUpdate && this.itemUpdate.content && this.itemUpdate.content != "") {
        ToolkitService.wallItemUpdate = true
        var stringOriginal = this.itemUpdate.contentDecrypted
        if (this.activeHighlight) {
          stringOriginal = this.highlightText(this.CLASS_HIGHLIGHTER, stringOriginal)
        } else if (this.activeEraseHighlight) {
          stringOriginal = this.highlightText(this.CLASS_NOT_HIGHLIGHTER, stringOriginal)
        }

        if (this.useMethodCommand() == false)
          this.itemUpdate.contentDecrypted = stringOriginal
      }
    } catch (error) {
      console.error(error)
    } finally {
      this.setWallFalse()
    }
  }

  public clearContent(content: string) {
    return content.replace(/[\n\r]+/g, '').replace(/[\s\u00A0]/g, " ").replace(/\s{2,}/g, ' ').replace(/&nbsp;/g, " ").replace(/<br\/>/g, "<br>");
  }

  public getItemUpdate(): Item {
    if (this.isActiveHighlight() && this.useMethodCommand() && this.itemUpdate != null) {

      var textOriginal = this.contentDecryp/// this.itemUpdate.contentDecrypted
      var highlightedElements = document.querySelectorAll("#editor span[style]");

      for (let i = 0; i < highlightedElements.length; i++) {
        const nodeHtml: any = highlightedElements[i]
        console.log(nodeHtml.style.background)
        const textoSubrayado = highlightedElements[i].innerHTML
        if (nodeHtml.attributes.style.value == "background-color: yellow;" && textoSubrayado) {
          console.log(textoSubrayado)
          const span = `<span style="background-color: yellow;">${textoSubrayado}</span>`;
          if (textOriginal.includes(textoSubrayado)) {
            textOriginal = textOriginal.replace(textoSubrayado, span);
          }
        }
      }
      this.itemUpdate.contentDecrypted = textOriginal
    }

    return this.itemUpdate
  }

  /** Método encargado de cargar el script para resaltar texto */
  public loadScript(nameScript) {
    $.getScript(nameScript, function (data, estado) {
      if (estado == 'success') {
        console.log("Cargado script");
      }
      else {
        alert("Error al cargar la librería autocomplete");
      }
    });
  }

  private useMethodCommand(): boolean {
    return typeof document.execCommand === 'function'
  }

  private highlightText(nameClass: string, stringOriginal: string): string {
    if (this.useMethodCommand()) {
      stringOriginal = this.highlight(nameClass, stringOriginal)
    } else {
      stringOriginal = this.highlightFallback(nameClass, stringOriginal)
    }

    return stringOriginal
  }


  private highlight(nameClass: string, stringOriginal: string): string {
    var range, sel;
    if (window.getSelection) {
      sel = window.getSelection();
      if (sel.getRangeAt) {
        range = sel.getRangeAt(0);
        var editorDiv = document.getElementById("editor");
        if (editorDiv.contains(range.startContainer) && editorDiv.contains(range.endContainer)) {
          document.designMode = "on";
          sel.addRange(range);
          if (nameClass == this.CLASS_HIGHLIGHTER) {
            document.execCommand('backColor', false, 'yellow')
          } else {
            document.execCommand('backColor', false, 'transparent')
          }
          document.designMode = "off"

        } else { alert("Estás intentando resaltar un espacio no válido.") }
        sel.removeAllRanges();
      }

    }

    return stringOriginal
  }

  private highlightFallback(nameClass: string, stringOriginal: string): string {
    var selection = window.getSelection();
    if (selection.rangeCount > 0) {
      var range = selection.getRangeAt(0);
      var fragment = document.createDocumentFragment();
      const selectedHTML = this.getHtmlRange(range)
      var startSelectHtml = this.getPositionOriginal(selectedHTML, range, stringOriginal, 1)
      const parentNode: any = range.startContainer.parentNode
      const selectedText = range.toString();
      if (selectedText.length == 1 && parentNode.nodeName == "SPAN") {
        if (nameClass == this.CLASS_HIGHLIGHTER) {
          parentNode.classList.add(this.CLASS_HIGHLIGHTER);
          parentNode.classList.remove(this.CLASS_NOT_HIGHLIGHTER);
        } else {
          parentNode.classList.add(this.CLASS_NOT_HIGHLIGHTER);
          parentNode.classList.remove(this.CLASS_HIGHLIGHTER);
        }
      } else {
        for (var i = 0; i < selectedText.length; i++) {
          var span = document.createElement("span");
          const randomPosition = Math.floor(Math.random() * 1000);
          var content = selectedText[i] === " " ? "\u00A0" : selectedText[i]; // Reemplazar espacios por &nbsp;
          span.textContent = content;
          if (selectedText[i] == " " || selectedText[i] == "\u00A0") {
            span.setAttribute("blanco", "1");
          }
          span.className = nameClass;
          span.setAttribute("position", randomPosition + "");

          fragment.appendChild(span);
        }

        // Reemplazar el contenido seleccionado con el fragmento resaltado
        range.deleteContents();
        range.insertNode(fragment);

      }
      selection.removeAllRanges();

      const finalHTML = this.getHtmlRange(range)
      selection.addRange(range);
      selection.removeAllRanges();

      stringOriginal = this.updateStringHtml(startSelectHtml, selectedHTML, finalHTML, stringOriginal)
    }

    return stringOriginal
  }


  private getPositionOriginal(selectedHTML: string, rangeSelected: any, stringOrigin: string, iteracion: number): number {
    var listPositions = this.findSubstring(selectedHTML, stringOrigin)
    var position = -1
    if (listPositions.length == 1) {
      position = listPositions[0]
    } else if (listPositions.length > 1) {
      position = listPositions[listPositions.length - 1]

      const parentElement = rangeSelected.startContainer.parentNode
      var stringSelectAll = selectedHTML
      if (parentElement.nodeName == "DIV") {
        stringSelectAll = parentElement.innerHTML.slice(rangeSelected.startOffset)
      } else {
        stringSelectAll = parentElement.innerHTML.slice(rangeSelected.startOffset, rangeSelected.startOffset + stringSelectAll.length + iteracion);
      }
      if (iteracion > 10)
        return position

      position = this.getPositionOriginal(stringSelectAll, rangeSelected, stringOrigin, iteracion + 1)
    }
    if (position == -1) {
      console.error(".... not found highlightText .. ")
      console.error(selectedHTML)
      console.error(stringOrigin)
    }


    return position
  }


  private resetHighLight() {
    this.activeHighlight = false
    this.activeEraseHighlight = false
    ToolkitService.wallItemUpdate = false
    this.disableSelectStart();
    $("#editor").css("cursor", "default");
  }


  public getHtmlRange(rangeSelected: any) {
    var tempDiv = document.createElement("div");
    tempDiv.appendChild(rangeSelected.cloneContents());
    var html = tempDiv.innerHTML.replace(/&nbsp;/g, " ").replace(/> </g, ">&nbsp;<").replace(/<br\/>/g, "<br>")

    if (html.length == 1) {
      var parentElement = rangeSelected.commonAncestorContainer;
      if (parentElement && parentElement.parentElement && parentElement.parentElement.nodeName == "SPAN") {
        html = parentElement.parentElement.outerHTML + ""
      }
    }

    return html;
  }

  private updateStringHtml(positionInitReplace: number, selectedHTML: string, finalHTML: string, stringOrigin: string) {
    var stringResult = stringOrigin + ""
    if (positionInitReplace != -1) {
      const part1 = stringOrigin.slice(0, positionInitReplace)
      const part3 = stringOrigin.slice(positionInitReplace + selectedHTML.length);
      stringResult = part1 + finalHTML + part3;
    }

    return stringResult
  }


  private findSubstring(wordFind: string, wordOrigin: string): number[] {
    const positions: number[] = [];
    let index: number = wordOrigin.indexOf(wordFind);
    while (index !== -1) {
      positions.push(index);
      index = wordOrigin.indexOf(wordFind, index + 1);
    }
    return positions;
  }

  /** activa o desactiva el resaltador */
  public changeHighLight() {
    this.activeHighlight = !this.activeHighlight
    this.activeEraseHighlight = false
    this.changeGeneralHighLight()

  }

  private changeGeneralHighLight() {
    if (this.activeHighlight == true || this.activeEraseHighlight == true) {
      $("#editor").css("cursor", "text");
      // permitir selección dentro del editor: quitamos el bloqueo
      this.enableSelectStart();
    } else {
      // deshabilitar selección en todo el body
      this.disableSelectStart();
      $("#editor").css("cursor", "default");
    }
  }


  /** activa o desactiva  el borrador resaltador */
  public changeEraseHighLight() {
    this.activeEraseHighlight = !this.activeEraseHighlight
    this.activeHighlight = false
    this.changeGeneralHighLight()
  }

  /** Encargado de abril el modal para ampliar imagen */
  public openZoomModal(open: boolean, url: string) {
    this.changeZoom.emit(open);
    this.urlZoom.emit(url);
  }

  /** Encargado de abrir el modal de notas rápidas */
  public showQuicknotes() {
    this.activateQuickNotes = true;
    $("#modalQuickNotes").show();
    $("#modalQuickNotes").draggable();
  }

  /** Encargado de abrir el modal de calculadora */
  public showCalculator() {
    this.activateCalculator = true;
    $("#modalCalculator").show();
    $("#modalCalculator").draggable();
  }


  /** Encargado de abrir el componente del pdf */
  public showPdf() {

    this.activateShowPdf = true;

    $("#modalShowPdf").show();
    $("#modalShowPdf").draggable();

  }

  /** Encargado de abrir el modal de calculadora */
  public showHtml() {
    if (this._configurationControlService.online) {
      this.activateShowHtml = true;
      $("#modalShowHtml").show();
      $("#modalShowHtml").draggable();
    }
    else {
      $('#component-html-error-form').modal({
        show: 'true'
      });

      const event = new KeyboardEvent('keydown', {
        altKey: false,
        code: 'F2',
        ctrlKey: false,
        key: 'F2',
        location: null,
        metaKey: false,
        repeat: false,
        shiftKey: false
      });

      document.dispatchEvent(event);

    }
  }
}
